import React from "react";
import classnames from "classnames";
import capitalize from "capitalize";
import config from "../../../../config";
import useApi from "../../../../api";
import { qs, formatPrice } from "../../../../utils";
import styles from "./RecentSearches.module.scss";
export var getRecentSearch = function getRecentSearch() {
  return JSON.parse(localStorage.getItem("recent-search")) || [];
};
export var saveRecentSearch = function saveRecentSearch(a) {
  var b = getRecentSearch(),
      c = b.indexOf(a);
  -1 < c && b.splice(c, 1), b.unshift(a), b.length = 4, localStorage.setItem("recent-search", JSON.stringify(b));
};
var TYPES = {
  house: "House & Land",
  townhome: "Townhomes",
  apartment: "Apartments",
  land: "Land for Sale"
};
export var RecentSearches = function RecentSearches(a) {
  var b = a.titleClass,
      c = a.onPackageClick,
      d = a.className,
      e = useApi(),
      f = e.filters.propertyType.options.length,
      g = getRecentSearch();
  return g.length ? /*#__PURE__*/React.createElement("div", {
    className: classnames(d, styles.container, "ta-row")
  }, g.map(function (a) {
    if (!a) return null;
    var b = qs.parse(a),
        d = b.bedrooms,
        e = void 0 === d ? "1-2" : d,
        g = b.bathrooms,
        h = void 0 === g ? "1-2" : g,
        i = b.stories,
        j = void 0 === i ? "1-2" : i,
        k = b.parking,
        l = void 0 === k ? "1-2" : k,
        m = b.price,
        n = void 0 === m ? "400000-1200000" : m,
        o = b.type,
        p = void 0 === o ? "all" : o,
        q = b.neighbourhood,
        r = b.estate,
        s = b.frontage,
        t = void 0 === s ? "All" : s,
        u = b.land_size,
        v = void 0 === u ? "All" : u,
        w = b.featured_options,
        x = void 0 === w ? [] : w,
        y = 1 < Object.keys(config.estates).length,
        z = r ? "string" == typeof r ? [r] : r || [] : "string" == typeof q ? [q] : q || [],
        A = (n || "").toString().split("-").map(function (a) {
      return formatPrice(a, {
        other: "($0a)",
        noPrice: "-"
      });
    });
    return /*#__PURE__*/React.createElement("a", {
      key: a,
      className: styles.wrapper,
      href: config.routes.get("property.results", "?".concat(a)),
      onClick: c
    }, /*#__PURE__*/React.createElement("h3", null, "land" === p ? "" : "".concat(A.join(" - "), " \u2022 "), "object" == typeof p && p ? p.length === f ? "all" : p.map(function (a) {
      return TYPES[a];
    }).join(", ") : "all" === p ? "all" : TYPES[p]), /*#__PURE__*/React.createElement("p", {
      className: styles.neighbourhoodsOrEstates
    }, z.length ? z.map(function (a) {
      return a.split("-").join(" ");
    }).join(" \u2022 ") : "all ".concat(y ? "".concat(config.labels.get("filters.estate"), "s") : config.labels.get("filters.neighbourhood"))), /*#__PURE__*/React.createElement("p", null, "land" === p ? "".concat(t, " Frontage \u2022 ").concat(v, " Land Size ").concat(x.length ? "\u2022 ".concat(x.map(function (a) {
      return capitalize(a);
    })) : "") : "".concat(e, " Bed \u2022 ").concat(h, " Bath \u2022 ").concat(j, " Storey \u2022 ").concat(l, " Park")));
  })) : /*#__PURE__*/React.createElement("div", {
    className: classnames(d, styles.container)
  }, /*#__PURE__*/React.createElement("p", {
    className: styles.paragraph
  }, "The searches you conduct will appear here."));
};
export default RecentSearches;